module.exports = __webpack_public_path__ + "flag_sgp.png?45dfbe41c1510aa088ec62c62baff3e7";


//////////////////
// WEBPACK FOOTER
// ./src/assets/flag_sgp.png
// module id = 35
// module chunks = 0